import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";


const _service = (options) => {
    options.baseURL = constants.utils.base.url;
    return axiosClient(options);
  };
  

const getJwtHeader = (json = true) => {
    const jwtToken = localStorage.getItem(ACCESS_TOKEN);
    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${jwtToken}`,
    };
    if (json) headers["Content-Type"] = "application/json";
    return headers;
  };



function getImportIdentity() {
    let profile = null;
    try {
      profile = JSON.parse(localStorage.getItem("profile") || "null");
    } catch {
      profile = null;
    }
    return {
      accountId: localStorage.getItem("accountId") || profile?.accountId || "",
      userId: localStorage.getItem("Uid") || profile?.userId || profile?.id || "",
    };
  }

function resolveProjectId(value) {
    if (value == null) return "";
    if (typeof value === "string" || typeof value === "number") return String(value).trim();
    return String(
      value.projectId ||
      value.project_id ||
      value.id ||
      ""
    ).trim();
  }

function importGithub(url, identity = {}) {
    const { accountId, userId } = getImportIdentity();
    const projectId = resolveProjectId(identity);
    const headers = getJwtHeader();
    if (projectId) headers["project-id"] = projectId;
    return _service({
        url: constants.api.codeIntelligence.importGithub,
        method: HTTP_METHODS.POST,
        headers,
        params: { accountId, userId, projectId },
        data: { url, accountId, userId, projectId },
    });
}

function importUpload(file, identity = {}) {
    const formData = new FormData();
    const { accountId, userId } = getImportIdentity();
    const projectId = resolveProjectId(identity);
    formData.append("file", file, file?.name || "archive.zip");
    formData.append("accountId", accountId);
    formData.append("userId", userId);
    formData.append("projectId", projectId);
    formData.append("project_id", projectId);
    const headers = getJwtHeader(false);
    delete headers["Content-Type"];
    if (projectId) headers["project-id"] = projectId;
    return _service({
        url: constants.api.codeIntelligence.importUpload,
        method: HTTP_METHODS.POST,
        headers,
        params: { accountId, userId, projectId },
        data: formData,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        transformRequest: [
          (data, requestHeaders) => {
            if (data instanceof FormData && requestHeaders) {
              delete requestHeaders["Content-Type"];
              delete requestHeaders["content-type"];
            }
            return data;
          },
        ],
    });
}

function getJob(jobId) {
    return _service({
        url: constants.api.codeIntelligence.jobStatus + jobId,
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function getResult(applicationId) {
    return _service({
        url: constants.api.codeIntelligence.result + applicationId + "/result",
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function getOverview(applicationId) {
    return _service({
        url: constants.api.codeIntelligence.overview + applicationId + "/overview",
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function listProducts() {
    return _service({
        url: constants.api.codeIntelligence.products,
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function getProduct(productId) {
    return _service({
        url: constants.api.codeIntelligence.product + productId,
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function getProductAnalyses(productId) {
    return _service({
        url: constants.api.codeIntelligence.product + productId + "/analyses",
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function getProductOverview(productId) {
    return _service({
        url: constants.api.codeIntelligence.product + productId + "/overview",
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function reanalyzeProduct(productId) {
    return _service({
        url: constants.api.codeIntelligence.reanalyze + productId + "/reanalyze",
        method: HTTP_METHODS.POST,
        headers: getJwtHeader(),
    });
}

function startModernize(productId) {
    return _service({
        url: constants.api.codeIntelligence.modernize + productId + "/modernize",
        method: HTTP_METHODS.POST,
        headers: getJwtHeader(),
    });
}

function getModernize(productId) {
    return _service({
        url: constants.api.codeIntelligence.modernize + productId + "/modernize",
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function normalizeStatusPath(statusUrl) {
    if (!statusUrl) return "";
    const text = String(statusUrl).trim();
    if (!text) return "";
    try {
        if (/^https?:\/\//i.test(text)) {
            const parsed = new URL(text);
            let path = `${parsed.pathname || ""}${parsed.search || ""}`.replace(/^\//, "");
            if (path.startsWith("api/code-intelligence/")) {
                path = `code-review/${path}`;
            }
            return path;
        }
    } catch {
        // fall through
    }
    let path = text.replace(/^\//, "");
    if (path.startsWith("api/code-intelligence/")) {
        path = `code-review/${path}`;
    }
    return path;
}

function getStatus(statusUrl) {
    const url = normalizeStatusPath(statusUrl);
    if (!url) {
        return Promise.resolve({ status: "FAILED", errorMessage: "Missing status url." });
    }
    return _service({
        url,
        method: HTTP_METHODS.GET,
        headers: getJwtHeader(),
    });
}

function getLocalSource({ workspaceId, path, file }) {
    return _service({
      url: constants.api.codeIntelligence.getLocal,
      method: HTTP_METHODS.POST,
      headers: getJwtHeader(),
      data: {
        workspaceId,
        path: path || "",
        file: file || "",
      },
    });
  }

const CodeIntelligenceService = {
    importGithub,
    importUpload,
    getJob,
    getResult,
    getOverview,
    listProducts,
    getProduct,
    getProductAnalyses,
    getProductOverview,
    reanalyzeProduct,
    startModernize,
    getModernize,
    getStatus,
    getLocalSource
};

export default CodeIntelligenceService;
